import React, { FC, useContext } from 'react';
import { PopupFooterProps } from './popupFooter.types';
import { StyledPopupFooterDiv } from './popupFooter.styles';
import TertiaryCta from '../tertiaryCta/tertiaryCta';
import clsx from 'clsx';
import { renderedData } from '../../SearchFormComponent';
import { ContentContext } from '../../index.contexts';
import { useConditionalSearchFormRenderedDataSERP } from '../../../../../../hooks/lib/useConditionalRenderedData';

const PopupFooter: FC<PopupFooterProps> = ({
  primaryBtnLabel,
  resetLabel,
  primaryBtnClickHandler,
  resetClickHandler,
  isSearchPage,
}) => {
  const clickTrackingLoc = 'Search Form';
  const { tabSelected } = useConditionalSearchFormRenderedDataSERP(renderedData);
  const { flexibleTabText } = useContext(ContentContext);

  return (
    <>
      {(primaryBtnLabel || resetLabel) && (
        <StyledPopupFooterDiv data-component-name="a-shop-PopupFooter" data-testid="shop-PopupFooter">
          {resetLabel && (
            <>
              <TertiaryCta
                clickHandler={resetClickHandler}
                label={resetLabel}
                className="reset-btn"
                isSearchPage={isSearchPage}
              />
              <div className="horizontal-line"></div>
            </>
          )}
          {primaryBtnLabel && (
            <button
              type="button"
              id="findHotelBtn"
              className={clsx(
                'custom_click_track,m-button-l,m-button-primary',
                tabSelected === flexibleTabText ? 'done-btn' : 'exact-btn'
              )}
              {...{
                custom_click_track_value: `${clickTrackingLoc}| Flexible Date Picker ${primaryBtnLabel} button |internal`,
              }}
              onClick={primaryBtnClickHandler}
            >
              {primaryBtnLabel}
            </button>
          )}
        </StyledPopupFooterDiv>
      )}
    </>
  );
};

export default PopupFooter;
